/*eslint-disable*/ export const messages = JSON.parse("{\"modal.aria.back\":[\"Takaisin\"],\"modal.aria.close\":[\"Sulje\"]}");
//# sourceMappingURL=messages.mjs.map